import * as yup from "yup";
import { STATUS_OPTIONS } from "../../constants/communityReview";
import { FormInputDropdown } from "../ui/form/Select";
import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Modal, Typography, Button } from "@mui/material";
import { useUpdateCommunityReview } from "./hooks/useCommunityReviewActions";

const validationSchema = yup.object({
  status: yup
    .string()
    .transform((v) => v || undefined)
    .oneOf(STATUS_OPTIONS.map((option) => option.value), "Invalid status")
    .required("Status is required")
}).required();

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  display: "flex",
  flexDirection: "column",
  gap: "32px"
};

export const BatchUpdateModal = ({ reviews, isOpen, onClose }) => {
  const { updateCommunityReview } = useUpdateCommunityReview();

  const {
    control,
    handleSubmit,
    formState: { isSubmitting }
  } = useForm({
    defaultValues: { status: "" },
    resolver: yupResolver(validationSchema)
  });

  const onSubmit = async (data) => {
    try {
      await Promise.all(
        reviews.map((review) =>
          updateCommunityReview.mutateAsync({
            id: review,
            data: {
              status: data.status
            }
          })
        )
      );
      onClose();
    } catch (error) {
      console.error("Error updating reviews:", error);
    }
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box sx={style}>
          <Typography variant="h6" component="h2" gutterBottom>
            Batch Update Reviews
          </Typography>

          <FormInputDropdown
            name="status"
            control={control}
            label="Status"
            options={STATUS_OPTIONS}
          />
          <Box display="flex" justifyContent="flex-end">
            <Button type="submit" disabled={isSubmitting} variant="contained" color="primary">
              Update
            </Button>
          </Box>
        </Box>
      </form>
    </Modal>
  );
};
